import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ic1 from '../../assets/editprofile.png';
import ic2 from '../../assets/paymentsettings.png';
import clockIcon from '../../assets/clock.svg';
import qrCode from '../../assets/QRCode.svg';
import { useNavigate } from 'react-router-dom';
import '../User/profilepage/Profilesettings.css';
import '../../VendorStyles/Vendorsettings.css';
import VendorEditProfile from './VendorEditProfile';
import VendorProfile from './VendorProfile';
import ChangePassword from './ChangePassword';
import BusinessHours from './BusinessHours';
import QRCodeGenerate from './QRCodeGenerate';
import PrinterSettings from './PrinterSettings';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ paddingTop: 6 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

export default function VendorsettingsMain() {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const { t } = useTranslation();

    const initialState = isDesktop ? 0 : undefined;
    const [value, setValue] = React.useState(initialState);
    const navigate = useNavigate();

    const mobtabs = [
        'edit-profile',
        'edit-vendor',
        'change-password',
        'business-hours',
        'qr-code',
        'printer-settings'
    ];

    useEffect(() => {
        const path = window.location.pathname.split('/').pop();
        const index = mobtabs.indexOf(path);
        if (index !== -1) {
            setValue(index);
        }
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (!isDesktop) {
            navigate(`/${mobtabs[newValue]}`);
        }
    };
    return (
        <div className='profile-settings-home-vendor'>
            <div className='Tabs-container'>
                <Box className='left-panel-vendor'>
                    <Tabs
                        orientation='vertical'
                        variant='scrollable'
                        value={value}
                        onChange={handleChange}
                        aria-label='Vertical tabs example'
                        className='Tabs-css'
                    >
                        <Tab
                            icon={<img src={ic1} alt='profile' className='tab-icon-img' />}
                            label={t('profilesettings.edit-profile-tab')}
                            className='left-tabs1'
                            {...a11yProps(0)}
                        />

                        <Tab
                            icon={<img src={ic1} alt='profile' className='tab-icon-img' />}
                            label='Edit Vendor'
                            className='left-tabs1'
                            {...a11yProps(1)}
                        />

                        <Tab
                            icon={
                                <img
                                    src={ic2}
                                    alt='Password'
                                    width='22px'
                                    height='17.71px'
                                    className='tab-icon-img'
                                />
                            }
                            label={t('profilesettings.change-password-tab')}
                            className='left-tabs1'
                            {...a11yProps(2)}
                        />
                        <Tab
                            icon={
                                <img
                                    src={clockIcon}
                                    alt='Password'
                                    width='22px'
                                    height='17.71px'
                                    className='tab-icon-img'
                                />
                            }
                            label='Business Hours'
                            className='left-tabs1'
                            {...a11yProps(3)}
                        />

                        <Tab
                            icon={
                                <img
                                    src={qrCode}
                                    alt='Password'
                                    width='22px'
                                    height='17.71px'
                                    className='tab-icon-img'
                                />
                            }
                            label='QR Code'
                            className='left-tabs1'
                            {...a11yProps(4)}
                        />
                        <Tab
                            icon={
                                <img
                                    src={ic2}
                                    alt='Printer'
                                    width='22px'
                                    height='17.71px'
                                    className='tab-icon-img'
                                />
                            }
                            label='Printer Settings'
                            className='left-tabs1'
                            {...a11yProps(5)}
                        />
                    </Tabs>
                </Box>
                {isDesktop && (
                    <Box
                        className='editprofile-main'
                        sx={{ display: 'flex', flexDirection: 'column' }}
                    >
                        <TabPanel value={value} index={0} sx={{ gap: '20px' }}>
                            <VendorEditProfile></VendorEditProfile>
                        </TabPanel>

                        <TabPanel value={value} index={1}>
                            <VendorProfile></VendorProfile>
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <ChangePassword></ChangePassword>
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            <BusinessHours></BusinessHours>
                        </TabPanel>
                        <TabPanel value={value} index={4}>
                            <QRCodeGenerate></QRCodeGenerate>
                        </TabPanel>
                        <TabPanel value={value} index={5}>
                            <PrinterSettings />
                        </TabPanel>
                    </Box>
                )}
            </div>
        </div>
    );
}
